<template>
  <div>
    <component
      :is="component"
      v-bind="linkAttributes"
      class="panel-mobile-menu-row w-full cursor-pointer text-menu-item transition hover:text-primary-500 dark:hover:bg-gray-800/80"
      :data-active-link="item.active"
      :class="{
        'panel-mobile-menu-row--active font-bold bg-primary-500 text-white dark:text-white shadow-[0_0_0_1px_rgba(59,130,246,0.14)]': item.active,
        'dark:text-gray-300': !item.active,
      }"
      @click="handleClick"
    >
      <span class="panel-mobile-menu-row__icon">
        <NavIcon :name="item.icon" width="20" height="20" />
      </span>

      <span class="panel-mobile-menu-row__label">
        {{ item.name }}
      </span>

      <span v-if="item.badge" class="panel-mobile-menu-row__badge shrink-0">
        <Badge :extra-classes="item.badge.typeClass">
          {{ item.badge.value }}
        </Badge>
      </span>
    </component>
  </div>
</template>

<script>
import identity from 'lodash/identity'
import isNull from 'lodash/isNull'
import omitBy from 'lodash/omitBy'
import pickBy from 'lodash/pickBy'
import { mapGetters, mapMutations } from 'vuex'
import NavIcon from './NavIcon.vue'

export default {
  components: {
    NavIcon,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapMutations(['toggleMainMenu']),

    handleClick() {
      if (this.mainMenuShown) {
        this.toggleMainMenu()
      }
    },
  },

  computed: {
    ...mapGetters(['mainMenuShown']),

    requestMethod() {
      return this.item.method || 'GET'
    },

    component() {
      if (this.requestMethod !== 'GET') {
        return 'FormButton'
      } else if (this.item.external !== true) {
        return 'Link'
      }

      return 'a'
    },

    linkAttributes() {
      let method = this.requestMethod

      return pickBy(
        omitBy(
          {
            href: this.item.path,
            method: method !== 'GET' ? method : null,
            headers: this.item.headers || null,
            data: this.item.data || null,
            rel: this.component === 'a' ? 'noreferrer noopener' : null,
            target: this.item.target || null,
          },
          isNull
        ),
        identity
      )
    },
  },
}
</script>
